<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <div class="c-form-item c-form-item-file-list" v-bind="{ ...wrapperAttrs }">
    <c-file-list v-if="fileItems?.length" :model-value="fileItems" :upload-type="uploadType" v-bind="innerAttrs" />
    <div v-else>{{ emptyText }}</div>
    <div v-if="title" class="title">{{ title }}</div>
  </div>
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script setup lang="ts">
import { _, computed, ref } from '@zto/zpage'

import { useFormItem } from '../util'

const props = withDefaults(
  defineProps<{
    model: Record<string, any>
    prop: string
    title?: string
    emptyText?: string
    wrapperAttrs?: Record<string, any>
    uploadType?: string
  }>(),
  {
    emptyText: '--'
  }
)
const { innerAttrs } = useFormItem(props)

const fileItems = computed(() => {
  const val = props.model[props.prop]
  if (!val) return []
  if (typeof val === 'string') {
    // 如果uploadType !== kt_store_file时，特殊处理
    if (props?.uploadType && props?.uploadType !== 'kt_store_file') {
      return [val]
    }
    return val.split(',')
  } else if (Array.isArray(val)) {
    return val
  } else if (typeof val === 'number') {
    return []
  } else {
    return [{ ...val, path: val.path || val.fileName, name: val.name || val.fileShowName }]
  }
})
</script>

<style lang="scss" scoped>
.c-form-item-image {
  padding: 5px;
  text-align: center;
}
</style>
